import template			from "./view-page.html";
import css				from "./view-page.css";

import {Tab} 	  		from "gui";
import InlineMessage	from "inlinemessage";


export default class Page extends Tab.Item {
  static get template() {
    return template;
  }
  
  static get css() {
    return css;
  }
  
  static {
    customElements.define("fulljs-view-page", Page);
  }

  constructor(...args) {
    super(...args);
  }

  showInformation(message) {
    this.inlineMessage?.remove();
    this.inlineMessage = this.divisionInlineMessage.appendChild( new InlineMessage({
      message,
      type: "information"
    }));    
  }

  showSuccess(message) {
    this.inlineMessage?.remove();
    this.inlineMessage = this.divisionInlineMessage.appendChild( new InlineMessage({
      message,
      type: "success"
    }));    
  }

  showWarning(message) {
    this.inlineMessage?.remove();
    this.inlineMessage = this.divisionInlineMessage.appendChild( new InlineMessage({
      message,
      type: "warning"
    }));    
  }

  showError(message) {
    this.inlineMessage?.remove();
    this.inlineMessage = this.divisionInlineMessage.appendChild( new InlineMessage({
      message,
      type: "error"
    }));    
  }
}